import React from 'react';
import { Link } from 'react-router-dom';
export function Logo() {
  return <Link to="/" className="flex items-center group shrink-0" data-id="element-316">
      <img src="https://cdn.magicpatterns.com/uploads/6QQqEPrZA2yuM42sncUeU3/StormLogo.png" alt="Storm Taekwondo" className="block h-14 md:h-16 w-auto object-contain transition-transform group-hover:scale-105" data-id="element-317" />
    </Link>;
}